import React, {useState, useEffect} from 'react';
import { Header } from './Header.js';
import { styles } from './Style.js';

import { AboutMe } from './AboutMe.js';
import { Games } from './Games.js';
import { Portfolio } from './Portfolio.js';
import { Game } from './Game.js';
import { SetGame } from './SetGame.js';

// Map a URL hash (e.g. #tic-tac-toe) to an internal page key.
function hashToPage(hash) {
    switch (hash) {
        case "#tic-tac-toe":
            return "tic-tac-toe-ai";
        case "#set-game":
            return "set-game";
        default:
            return null;
    }
}

export function Website(props) {
    const renderPage = (key) => {
        switch (key) {
            case "about-me":
                return <AboutMe changePage={changePage} />;
            case "games":
                return <Games changePage={changePage} />;
            case "portfolio":
                return <Portfolio changePage={changePage} />;
            case "tic-tac-toe-ai":
                return <Game changePage={changePage} />;
            case "set-game":
                return <SetGame changePage={changePage} />;
            default:
                return <AboutMe changePage={changePage} />;
        }
    };
    const changePage = (p) => setPage(renderPage(p.page));

    // Honor a hash in the URL on first load (e.g. harrybaldwig.com#set-game).
    const [page, setPage] = useState(() => renderPage(hashToPage(window.location.hash) || "about-me"));

    // ...and react to later hash changes (back/forward buttons, pasted links).
    useEffect(() => {
        const onHashChange = () => {
            const key = hashToPage(window.location.hash);
            if (key) setPage(renderPage(key));
        };
        window.addEventListener("hashchange", onHashChange);
        return () => window.removeEventListener("hashchange", onHashChange);
    }, []);

    return (
        <div style={styles.Website}>
            <Header changePage={changePage} />
            {page}
        </div>
    );
};
